import { PendingContractAction, PendingContractState } from "./types";

export const setPendingContractRecord = (payload: PendingContractState) =>
  ({
    type: PendingContractAction.SET_PENDING_CONTRACT_RECORD,
    payload,
  }) as const;

export const getPendingContractRecord = (payload) =>
  ({
    type: PendingContractAction.GET_PENDING_CONTRACT_RECORD,
    payload,
  }) as const;

export const cleanUpPendingContract = () =>
  ({
    type: PendingContractAction.CLEAN_UP,
  }) as const;

export const createPendingContract = (payload: any, callback = () => {}) =>
  ({
    type: PendingContractAction.CREATE_PENDING_CONTRACT,
    payload,
    callback,
  }) as const;

export const importPendingContract = (
  file: File,
  dealerId: string,
  callback = (importedCount: number, failedRecords: string) => {}
) =>
  ({
    type: PendingContractAction.IMPORT_PENDING_CONTRACT,
    file,
    dealerId,
    callback,
  }) as const;

export const uploadDocuments = (files: File[], callback = () => {}) =>
  ({
    type: PendingContractAction.UPLOAD_DOCUMENTS,
    files,
    callback,
  }) as const;

export const setUploadedDocuments = (payload: any) =>
  ({
    type: PendingContractAction.SET_UPLOADED_DOCUMENTS,
    payload,
  }) as const;
